import React, { Component } from 'react';
import Header from '../header/header';

class Contact extends Component {

  render() {
    return (
      <div>
        <div className="contact-section">
          <Header />
        </div>
      </div>
    );
  }

}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/contact/contact.js